import { useState, useRef, useEffect } from 'react'

/**
 *
 * @param time sets the timeout for the action to be fired
 * @returns {
 *      @nodeRef the ref value to pass to `react-transition-group` Transition
 *      @animated the state value as a boolean
 *      @setAnimated the function to update the state
 * }
 *
 */
export const useAnimationState = (time = 200) => {
    const [animated, setAnimated] = useState(false)
    const nodeRef = useRef(null)

    useEffect(() => {
        const id = setTimeout(() => setAnimated(true), time)
        return () => {
            clearTimeout(id)
        }
    }, [time])

    return {
        nodeRef,
        animated,
        setAnimated,
    }
}
